document.addEventListener("DOMContentLoaded", function () {
    // Select all open-sub-menu buttons
    const openButtons = document.querySelectorAll(".open-sub-menu");

    // Add click event listeners to each open button
    openButtons.forEach((button) => {
        button.addEventListener("click", function () {
            toggleMenu(this);
        });

        // If the current page is the active page, its parent submenu should be open.
        const subMenu = button.nextElementSibling;
        const currentItem = subMenu.querySelector('.current-menu-item');
        if (currentItem) {
            toggleMenu(button);
        }
    });
});

function toggleMenu(button) {
    // Find the sibling sub-menu
    const subMenu = button.nextElementSibling;

    // Toggle the 'open' class on the sub-menu
    subMenu.classList.toggle("open");

    // Update the button image based on the sub-menu's visibility
    const imgElement = button.querySelector('img');
    if (subMenu.classList.contains("open")) {
        imgElement.src = imgElement.src.replace('aps-section-menu-plus.svg', 'aps-section-menu-minus.svg');
    } else {
        imgElement.src = imgElement.src.replace('aps-section-menu-minus.svg', 'aps-section-menu-plus.svg');
    }
}
